// Single source of truth for resolving an event's form style / builder variant.
//
// form_style is read in many places (booking widget dispatch in both apps, the
// event-list badge, builder routing). Those sites historically use bare
// `form_style === 'slide'` equality, which silently treats any unknown value
// (including 'smartflow') as stepped — that fall-through is the intended
// Phase-1 behaviour (a SmartFlow event renders as stepped until its renderer
// ships). New code (builder routing, the list badge) reads the variant through
// getFormVariant() instead. When the SmartFlow booking renderer lands, migrate
// the widget dispatch sites here too and switch them to an exhaustive
// switch (with an assertNever default) so future variants fail to compile.

import type { FormStyleType } from '../types/booking';

export type FormVariant = 'stepped' | 'slide' | 'smartflow';

/** Resolve an event's form variant, defaulting null/unknown to 'stepped'. */
export function getFormVariant(formStyle: FormStyleType | null | undefined): FormVariant {
  return formStyle === 'slide' || formStyle === 'smartflow' ? formStyle : 'stepped';
}

/** True when the event uses the SmartFlow (EventBuilder 2.0) style. */
export function isSmartFlow(formStyle: FormStyleType | null | undefined): boolean {
  return getFormVariant(formStyle) === 'smartflow';
}
